import { render } from "./App.vue?vue&type=template&id=4b7229f0&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=4b7229f0&lang=css"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/funds_prod_deploy/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__